/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LocationDto } from './LocationDto';
import type { PlannedDateTimeRangeDto } from './PlannedDateTimeRangeDto';
import type { TransportationActivityDto } from './TransportationActivityDto';
export type DispatchDeliveryOrderStageDto = {
    actualAppointmentDate?: string;
    actualPickDate?: string;
    currentActivityType: DispatchDeliveryOrderStageDto.currentActivityType;
    activityId?: string;
    activity?: TransportationActivityDto;
    appointmentDate?: string;
    location?: LocationDto;
    pickDate?: string;
    plannedAppointmentDateTimeRange?: PlannedDateTimeRangeDto;
    plannedPickDateTimeRange?: PlannedDateTimeRangeDto;
    spentTimeSpan?: number;
    shuttle?: boolean;
};
export namespace DispatchDeliveryOrderStageDto {
    export enum currentActivityType {
        GOTO = 'GOTO',
        BOBTAIL_GOTO = 'BOBTAIL_GOTO',
        EMPTY = 'EMPTY',
        OFF_DUTY = 'OFF_DUTY',
        PICK_UP_EMPTY = 'PICK_UP_EMPTY',
        PICK_UP_FULL = 'PICK_UP_FULL',
        GET_UNLOADED = 'GET_UNLOADED',
        GET_LOADED = 'GET_LOADED',
        DROP_EMPTY_WITH_CHASSIS = 'DROP_EMPTY_WITH_CHASSIS',
        DROP_FULL_WITH_CHASSIS = 'DROP_FULL_WITH_CHASSIS',
        PICK_CHASSIS = 'PICK_CHASSIS',
        DROP_CHASSIS = 'DROP_CHASSIS',
        DROP_EMPTY_WITH_OUT_CHASSIS = 'DROP_EMPTY_WITH_OUT_CHASSIS',
        DROP_FULL_WITH_OUT_CHASSIS = 'DROP_FULL_WITH_OUT_CHASSIS',
        SCALE_TARE = 'SCALE_TARE',
        SCALE_FULL = 'SCALE_FULL',
    }
}

